import { render } from "./head-block.vue?vue&type=template&id=8ec23a48&scoped=true"
import script from "./head-block.vue?vue&type=script&lang=js"
export * from "./head-block.vue?vue&type=script&lang=js"

import "./head-block.vue?vue&type=style&index=0&id=8ec23a48&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ec23a48"]])

export default __exports__